export default "__VITE_ASSET__BtWze2US__"